export default class serventiaFilters {
    public static readonly ativos = "Mostrar ativos";
    public static readonly excluidos = "Mostrar excluídos";
    public static readonly todos = "Mostrar todos";
    public static readonly favoritos = "Mostrar favoritos";
}